import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { IAccountNote } from '~/types/note/models'

export const {
  getNoteListData: getAccountNoteListData,
  getNoteDataById: getAccountNoteDataById,
  getNoteListDataByParentId: getAccountNoteListDataByAccountId,
} = makeNoteMockData<IAccountNote>({
  entityName: 'account',
  storageKeyPrefix: 'account',
})
